import { useTranslation } from 'react-i18next';
import { useLocale } from '@/hooks/useLocale';

const SCENARIOS = [['baseline', 94700, 156100, '9–11'], ['internal', 78500, 148300, '10–13'], ['consultant', 121400, 169800, '7–9']];
export const ScenarioPreview = () => {
  const { t } = useTranslation();
  const { lang } = useLocale();
  const money = value => new Intl.NumberFormat(lang, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value);
  return <section className="lp-section lp-scenarios" data-testid="landing-scenarios" aria-labelledby="landing-scenarios-title">
    <div className="lp-container">
      <div className="lp-section-header">
        <h2 id="landing-scenarios-title" data-testid="landing-scenarios-title">{t('homepage.scenarios.heading')}</h2>
        <span className="lp-example-label" data-testid="landing-scenarios-label">{t('homepage.exampleLabel')}</span>
      </div>
      <p className="lp-section-intro" data-testid="landing-scenarios-description">{t('homepage.scenarios.body')}</p>
      <div className="lp-scenario-grid">
        {SCENARIOS.map(([key, year1, outlook, months]) => <article key={key} className="lp-scenario" data-testid={`landing-scenario-${key}`}>
          <h3>{t(`homepage.scenarios.${key}`)}</h3>
          <dl>
            <div><dt>{t('homepage.scenarios.year1')}</dt><dd data-testid={`landing-scenario-${key}-year1`}>{money(year1)}</dd></div>
            <div><dt>{t('homepage.scenarios.outlook')}</dt><dd data-testid={`landing-scenario-${key}-outlook`}>{money(outlook)}</dd></div>
            <div><dt>{t('homepage.preview.timeline')}</dt><dd data-testid={`landing-scenario-${key}-timeline`}>{months} {t('homepage.months')}</dd></div>
          </dl>
        </article>)}
      </div>
      <p className="lp-small-note" data-testid="landing-scenarios-caveat">{t('homepage.scenarios.note')}</p>
    </div>
  </section>;
};